module.exports = __webpack_public_path__ + "media/react/pages/add_ons/assets/gmat_live_classes/derrick-d13c7af5e0a63edaa918f8e6b04010b4.png";